import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    root: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: COLOR.BLACK,
    },
    channelLogoWrapper: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
    },
    channelLogo: {
        width: ImageSize.ZAPPING_OVERLAY_CHANNEL_LOGO.width,
        aspectRatio: 16 / 9,
    },
});

export default styles;
